@if (isRmbRmc && !isAddAnother) {
<p>{{ "OTHER_COVERAGE_STATICTEXT14" | globalTranslate }}</p>
} @if (getValue('extras.topLevelAnswer') === 'YES') {
<div form-top>
  <h1 class="person-label" [attr.aria-hidden]="!selectedIndividual ? 'true' : null">
    {{ selectedIndividual | fullname }}
  </h1>
</div>
}
<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  class="label-section"
  [topLevelQuestion]="conditionalTopLevelQuestion | globalTranslate"
  individualQuestion="{{ this.individualQuestion | globalTranslate }}"
  hintText="{{ hintText }}"
  (validate)="onValidate($event)"
  [topLevelName]="'emp'"
>
  <section [formGroup]="getControl('data')">
    @if (isEnabled('data.loseJobSw')) {
    <nh-field
      id="emp_loseJobSw"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'EMPLOYMENT_STATIC_TEXT1' | globalTranslate }}{{
        selectedIndividual | fullname
      }} {{ 'EMPLOYMENT_STATIC_TEXT2' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="loseJobSw"
        [attr.aria-label]="
          ('EMPLOYMENT_STATIC_TEXT1' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('EMPLOYMENT_STATIC_TEXT2' | globalTranslate)
        "
        [items]="tableCodeValue('YESNO', 'data.loseJobSw')"
        formControlName="loseJobSw"
      ></select>
    </nh-field>
    } @if (isEnabled('data.loseJobEndDate')) {
    <nh-field
      id="emp_loseJobEndDate"
      label="{{ 'EMPLOYMENT_STATIC_TEXT3' | globalTranslate }} {{
        selectedIndividual | fullname
      }} {{ 'EMPLOYMENT_STATIC_TEXT4' | globalTranslate }}"
      class="label-section"
    >
      <nh-datepicker>
        <input
          type="text"
          [attr.aria-label]="
            ('EMPLOYMENT_STATIC_TEXT3' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            '' +
            ('EMPLOYMENT_STATIC_TEXT4' | globalTranslate)
          "
          class="form-control"
          (change)="isInvalidEndDate($event)"
          [minDate]="minimumloseJobEndDate"
          [maxDate]="today"
          name="loseJobEndDate"
          formControlName="loseJobEndDate"
          bsDatepicker
          nh
          maxlength="10"
        />
      </nh-datepicker>
      @if (errorMessage) {
      <span class="form-text invalid-tooltip d-block">{{
        "INVALID_JOB_START_DATE" | globalTranslate
      }}</span>
      }
    </nh-field>
    }
  </section>

  <section>
    <fieldset [formGroup]="getControl('data.employer')">
      <h2 class="section-header">
        {{ "EMPLOYMENT_STATIC_TEXT5" | globalTranslate }}
      </h2>
      <hr />
      <nh-field
        id="emp_name"
        label="{{ 'EMPLOYMENT_STATIC_TEXT6' | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          [attr.aria-label]="'EMPLOYMENT_STATIC_TEXT6' | globalTranslate"
          name="employerName"
          maxlength="100"
          class="form-control"
          required
          formControlName="name"
        />
      </nh-field>
      <h2 class="section-header">
        {{ "EMPLOYMENT_STATIC_TEXT7" | globalTranslate }}
      </h2>
      <hr />

      <nh-alert
        type="warning"
        [isOpen]="
          getControl('data.employer.address').touched &&
          isEmpty('data.employer.address.addressLine1') &&
          isEmpty('data.employer.address.city')
        "
      >
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
              alt=""
            />
          </div>
          <div class="col message">
            <span>{{ "EMP_ADDRESS_WARNING" | globalTranslate }}</span>
          </div>
        </div>
      </nh-alert>

      <nh-name-address
        [addressname]="'emp'"
        [addressFieldMandatory]="false"
        [stateDefault]="false"
        [showPopup]="false"
        [address]="getControl('data.employer.address')"
        [tables]="tables"
        [hideCounty]="true"
      ></nh-name-address
      ><br />
      <nh-field
        id="emp_phoneNumber"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'EMPLOYMENT_STATIC_TEXT8' | globalTranslate }}"
        class="label-section"
      >
        <input
          type="text"
          name="employerphoneNumber"
          [attr.aria-label]="'EMPLOYMENT_STATIC_TEXT8' | globalTranslate"
          formControlName="phoneNumber"
          class="form-control"
          mask="000-000-0000"
          placeholder="XXX-XXX-XXXX"
        />
      </nh-field>
    </fieldset>
    <br />
  </section>

  <section [formGroup]="getControl('data')">
    <nh-field
      id="emp_startDate"
      [mandatory]="false"
      [attr.aria-required]="false"
      [option]="startDateOption"
      label="{{ 'WHEN_DID_1' | globalTranslate }} {{
        selectedIndividual | fullname
      }} {{ 'EMPLOYMENT_STATIC_TEXT10' | globalTranslate }}"
      class="label-section"
    >
      <nh-datepicker>
        <input
          type="text"
          [attr.aria-label]="
            ('WHEN_DID_1' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('EMPLOYMENT_STATIC_TEXT10' | globalTranslate)
          "
          class="form-control"
          [minDate]="minDate"
          [maxDate]="maxJobStartDate"
          name="startDate"
          (change)="isInvalidStartDate($event)"
          formControlName="startDate"
          bsDatepicker
          nh
        />
      </nh-datepicker>
      @if (startDateErrorMessage) {
      <span class="form-text invalid-name invalid-date-bold d-block">{{
        "INVALID_FUTURE_DATE" | globalTranslate
      }}</span>
      }
    </nh-field>
  </section>
  <h2 class="section-header">
    {{ "EMPLOYMENT_STATIC_TEXT11" | globalTranslate }}
  </h2>
  <hr />
  <section [formGroup]="getControl('data.wage')">
    <nh-field
      id="emp_paymentOption"
      label="{{ 'EMPLOYMENT_STATIC_TEXT12' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'EMPLOYMENT_STATIC_TEXT13' | globalTranslate }} "
      class="label-section"
    >
      <div class="hint">
        {{ "EMPLOYMENT_STATIC_TEXT14" | globalTranslate }}
        {{ selectedIndividual | fullname }}
        {{ "EMPLOYMENT_STATIC_TEXT15" | globalTranslate }}
      </div>
      <select
        nhTranslate
        name="paymentOption"
        [attr.aria-label]="
          ('EMPLOYMENT_STATIC_TEXT12' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('EMPLOYMENT_STATIC_TEXT13' | globalTranslate) +
          ' ' +
          ('EMPLOYMENT_STATIC_TEXT14' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('EMPLOYMENT_STATIC_TEXT15' | globalTranslate)
        "
        [items]="tableCodeValue('MPPAYFREQ', 'extras.helpers.paymentOption')"
        [formControl]="getControl('extras.helpers.paymentOption')"
        (change)="paymentOptionChange()"
        required
      ></select>
    </nh-field>
  </section>
  @if (isEnabled('data.wage.hoursWorkedPeriod')) {
  <section [formGroup]="getControl('data.wage')">
    <nh-field
      id="emp_hoursWorkedPeriod"
      label="{{ 'EMPLOYMENT_STATIC_TEXT16' | globalTranslate }} {{
        selectedIndividual | fullname
      }} {{ 'EMPLOYMENT_STATIC_TEXT17' | globalTranslate }}"
      class="label-section"
    >
      <input
        nh
        type="decimal"
        maxlength="6"
        name="hoursWorkedPeriod"
        [attr.aria-label]="
          ('EMPLOYMENT_STATIC_TEXT16' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('EMPLOYMENT_STATIC_TEXT17' | globalTranslate)
        "
        formControlName="hoursWorkedPeriod"
        class="form-control"
        required
      />
    </nh-field>
    <nh-field
      id="emp_paymentAmtPerHr"
      label="{{ 'EMPLOYMENT_STATIC_TEXT18' | globalTranslate }} {{
        selectedIndividual | fullname
      }} {{ 'EMPLOYMENT_STATIC_TEXT19' | globalTranslate }}"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="text"
          [attr.aria-label]="
            ('EMPLOYMENT_STATIC_TEXT18' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('EMPLOYMENT_STATIC_TEXT19' | globalTranslate)
          "
          placeholder="0.00"
          mask="separator.2"
          thousandSeparator=""
          separatorLimit="999999999"
          name="paymentAmtPerHr"
          formControlName="paymentAmtPerHr"
          class="form-control"
          required
        />
      </nh-input-group>
    </nh-field>
  </section>
  } @if (isEnabled('data.wage.paymentPeriod')) {
  <section [formGroup]="getControl('data.wage')">
    <nh-field
      id="emp_paymentPeriod"
      label="{{ 'EMPLOYMENT_STATIC_TEXT20' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'EMPLOYMENT_STATIC_TEXT21' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="paymentPeriod"
        [attr.aria-label]="
          ('EMPLOYMENT_STATIC_TEXT20' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('EMPLOYMENT_STATIC_TEXT21' | globalTranslate)
        "
        [items]="
          tableCodeValue('INCEXPPAYFREQUENCY', 'data.wage.paymentPeriod')
        "
        formControlName="paymentPeriod"
        required
      ></select>
    </nh-field>
    <nh-field
      id="emp_paymentAmountPerPayCheck"
      label="{{ 'EMPLOYMENT_STATIC_TEXT22' | globalTranslate }} {{
        selectedIndividual | fullname
      }} {{ 'EMPLOYMENT_STATIC_TEXT23' | globalTranslate }} "
      class="label-section"
      [col9]="true"
    >
      <nh-popover
        class="ps-1"
        [content]="payCheckText | globalTranslate"
      ></nh-popover>
      <nh-input-group prepend="$">
        <input
          nh
          type="text"
          placeholder="0.00"
          mask="separator.2"
          thousandSeparator=""
          separatorLimit="999999999"
          name="paymentAmountPerPayCheck"
          [attr.aria-label]="
            ('EMPLOYMENT_STATIC_TEXT22' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('EMPLOYMENT_STATIC_TEXT23' | globalTranslate)
          "
          formControlName="paymentAmountPerPayCheck"
          class="form-control"
          required
        />
      </nh-input-group>
    </nh-field>
  </section>
  }
</nh-form>